import React, { useContext } from 'react';

const RoutesContext = React.createContext([]);

export const useRoutes = () => {
  return useContext(RoutesContext);
};

export default RoutesContext;